import { Component, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { Filter } from "@merchant_app/storage/funding/funding.state";
import { LocalTimePoint } from "shared-lib";
import { FundingStatus } from "@merchant_api/models/funding-status";
import { ProcessorEnum } from "@merchant_api/models/processor-enum";

@Component({
    selector: "app-funding-log-filters",
    templateUrl: "./funding-log-filters.component.html",
    styleUrls: ["./funding-log-filters.component.less"],
    standalone: false
})
export class FundingLogFiltersComponent {

    @Output() filterChanged = new EventEmitter<Filter>();
    @Input() filter: Filter;

    LocalTimePoint = LocalTimePoint;

    fundingStatusList: Array<FundingStatus>;
    processorList: Array<ProcessorEnum>;

    constructor(
        private fb: UntypedFormBuilder
    ) {
        this.fundingStatusList = Object.values(FundingStatus);

        // Remove 'Processing' item from current position
        const processingIndex = this.fundingStatusList.findIndex((element) => element === FundingStatus.Processing);
        this.fundingStatusList.splice(processingIndex, 1);

        this.processorList = Object.values(ProcessorEnum);
    }

    filterForm = this.fb.group({
        localDateInterval: [null],
        fundingStatuses: [null],
        mid: [null],
        dba: [null],
        localFundedDateInterval: [null],
        processors: [null]
    });

    onFilterChanged(filter: Filter) {
        this.filterChanged.emit(filter);
    }

    wipeField(fieldName: string) {
        this.filterForm.get(fieldName).setValue(undefined);
        this.filterForm.updateValueAndValidity();
    }

}
